import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { OldMangoButton } from '~/components/core/OldMangoButton'

import { light, spacing } from '../constants/theme'
import { desktop } from '../styles'
import { Text } from './core'

export const MangoPlusAdsWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding: 64px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: ${light.gray400};
  background-size: cover;
  background-repeat: no-repeat;
  overflow: auto;

  &::-webkit-scrollbar {
    width: ${desktop.scrollbar}px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: ${desktop.scrollbar}px;
    -webkit-box-shadow: inset 0px 4px 14px rgba(0, 0, 0, 0.1);
    background-color: ${light.gray400};
  }

  @media screen and (max-width: ${desktop.breakXL}px) {
    display: block;
    padding: 40px;
  }
`

export const AdsContentsWrapper = styled.div`
  width: 65%;
  padding-top: ${spacing.spacingXL};
  box-sizing: border-box;
  > p {
    margin-bottom: ${spacing.spacingXL};
  }
  > div {
    margin-top: ${spacing.spacingXXL};
  }
`

export const AdsTitleWrapper = styled.div`
  width: 100%;

  // space between "relevant" & "in"
  span:first-child {
    margin-right: ${spacing.spacingLG};
  }

  @media screen and (max-width: ${desktop.breakXL}px) {
    width: 100%;
  }
`

export const AdsTitle = styled.span`
  color: ${(props) => (props.color ? props.color : light.dark900)};
`

const MangoPlusAds = ({ onUpgrade }) => {
  return (
    <MangoPlusAdsWrapper>
      <AdsTitleWrapper>
        <Text size="superLarge" color={light.dark900}>
          <AdsTitle color={light.primary}>Stay relevant</AdsTitle>
          <AdsTitle>in today’s world</AdsTitle>
        </Text>
        <AdsContentsWrapper>
          <Text
            size="normal"
            color={`${light.dark800}`}
            text="Who doesn’t like texting?"
            weight="bold"
          />
          <Text
            size="normal"
            color={`${light.dark800}`}
            text="In today’s world, people love texting over phone calls. Choose to text your customers-save time and energy!"
          />
          <Text
            size="normal"
            color={`${light.dark800}`}
            text="Texting is just one of the many Mango Plus perks. Talk to our Sales Team about a month trial before you buy."
          />
          <OldMangoButton onClick={onUpgrade}>Learn More</OldMangoButton>
        </AdsContentsWrapper>
      </AdsTitleWrapper>
    </MangoPlusAdsWrapper>
  )
}

MangoPlusAds.propTypes = {
  onUpgrade: PropTypes.func,
}

MangoPlusAds.defaultProps = {
  onUpgrade: () => {},
}

export default MangoPlusAds
